import Cookies from "js-cookie";

const getUser = () => {
    const userCookie = Cookies.get("user");
    return JSON.parse(userCookie);
};

const getAccessToken = () => {
    return Cookies.get("accessToken") || null;
};

// get permissions from user object
const getPermissions = () => {
    const user = getUser();
    return user.permissions || [];
};

// implements hasPermission function
const hasPermission = (permission) => {
    const permissions = getPermissions();
    return permissions.includes(permission);
};

const setCookie = (key, value) => {
    Cookies.set(key, value, {
        sameSite: 'None', 
        secure: true,
        expires: 1
    });
};

export { 
    getUser,
    getAccessToken,
    getPermissions,
    hasPermission,
    setCookie
};